import {
    FETCH_UPDATE_GROUP_REQUEST,
    FETCH_UPDATE_GROUP_SUCCESS,
    FETCH_UPDATE_GROUP_FAILURE,
    SET_UPDATE_GROUP
} from '../../actions/groups/update-groups-actions';

const initialState = {
    updatedGroup: null,
    group: null,
    isLoading: false,
    error: null,
};

const CLEAR_DATA = "CLEAR_DATA";
const UpdateGroupReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_UPDATE_GROUP_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case SET_UPDATE_GROUP:
            return {
                ...state,
                isLoading: false,
                error: null,
                group: { ...action.payload }
            };
        case FETCH_UPDATE_GROUP_SUCCESS:
            return {
                ...state,
                isLoading: false,
                updatedGroup: action.payload[0],
            };
        case FETCH_UPDATE_GROUP_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        case CLEAR_DATA:
            return {
                ...initialState
            };
        default:
            return state;
    }
};

export default UpdateGroupReducer;